import axios from '../../plugins/axios.js';

export default{
  async getCallPaths() {
    return await axios.get('api/CallPath');
  },
  async getCallPathStatuses() {
    return await axios.get('api/CallPath/CallPathStatus');
  },
  async archiveCallPath(CallPathsValues) {
    return await axios.post('/api/CallPath/ArchiveCallPath', CallPathsValues);
  },
  async getCallPathPrompts(id) {
    return await axios.get('/api/CallPathPrompt/id?callPathId=' + id);
  },
  async getCallPathPromptConnections(id) {
    return await axios.get('/api/CallPathPromptConnection/id?id=' + id);
  },
  async updateCallPath(callPath) {
    return await axios.put('/api/CallPath/', callPath);
  },
  async getCallPathByID(callPathId) {
    return await axios.get(`/api/CallPath/${callPathId}`);
  }, 
  async getCallPathsByPromptID(promptID) {  
    return await axios.get(`/api/CallPathPrompt/${promptID}`);
  }, 
  async getCallPathEntities() {  
    return await axios.get(`/api/CallPath/GetCallPathEntities`);
  }, 
};
